import styled from 'styled-components';

export const SectionContainer = styled.div<{
  orientation?: 'left' | 'right';
}>`
  display: flex;
  gap: 4rem;
  flex-direction: ${({ orientation }) =>
    orientation === 'right' ? 'row' : 'row-reverse'};
  justify-content: space-between;
  align-items: center;
  padding: 7.5rem 0;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column-reverse;
    padding: 3rem 2rem;
  }
`;

export const ContentContainer = styled.div<{ maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  margin: 0 auto;
`;

export const HighlightText = styled.h3`
  color: #009fe3;
  font-family: proxima-nova, sans-serif;
  font-size: 20px;
  font-weight: 800;
  line-height: 140%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 18px;
  }
`;

export const Title = styled.h1`
  font-family: proxima-nova, sans-serif;
  font-size: 40px;
  font-weight: 900;
  line-height: 115%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 32px;
  }
`;

export const Paragraph = styled.p`
  font-family: proxima-nova, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 16px;
    line-height: 140%;
  }
`;

export const ImageContainer = styled.div<{
  maxHeight?: string;
  maxWidth?: string;
}>`
  max-height: ${({ maxHeight }) => maxHeight ?? '570px'};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    order: 1;
    max-width: 100%;
    width: 100%;
  }
`;

export const EventImage = styled.img<{
  orientation?: 'left' | 'right';
  $height: string;
}>`
  border-top-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-bottom-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-top-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};
  border-bottom-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};
  width: 100%;
  height: ${({ $height }) => $height || '100%'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    border-radius: 0;
    margin-left: -2rem;
    height: 238px;
    width: calc(100% + 2rem);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const EventVideo = styled.video<{
  orientation?: 'left' | 'right';
  maxHeight?: string;
}>`
  border-top-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-bottom-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-top-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};
  border-bottom-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};
  width: 100%;
  height: ${({ maxHeight }) => maxHeight ?? '713px'};
  object-fit: contain;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    border-radius: 0;
    width: calc(100% + 2rem);
    margin-left: -2rem;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    height: auto;
  }
`;
